import protoRoot from "../proto-root";
import ActivityLogEvent from "./ActivityLogEvent";

function create({ thumbnailData, event }) {
  const ActivityLogVideoPreview = protoRoot.lookupType(
    "comm.ActivityLogVideoPreview"
  );

  return ActivityLogVideoPreview.create({
    event: ActivityLogEvent.create(event),
    thumbnailData
  });
}

export default {
  create
};

// message ActivityLogVideoPreview {
//     ActivityLogEvent event = 1;
//     // JPEG data prvního snímku videa
//     bytes thumbnailData = 2;
// }
